import { Head, router, usePage } from '@inertiajs/react';
import { useMemo, useState } from 'react';

import { MessagesTable } from '@/components/admin/messages/MessagesTable';
import type { Message } from '@/components/admin/messages/MessagesTable';
import { FilterTabs } from '@/components/ui/FilterTabs';
import { SearchBar } from '@/components/ui/SearchBar';

const STATUS_TABS = [
  { label: 'Todas', value: 'all' },
  { label: 'Pendentes', value: 'pending' },
  { label: 'Resolvidas', value: 'handled' },
  { label: 'Arquivadas', value: 'dismissed' },
];

interface MessagesPageProps {
  messages: Message[];
  [key: string]: unknown;
}

export default function Messages() {
  const { messages } = usePage<MessagesPageProps>().props;
  const [statusFilter, setStatusFilter] = useState('pending');
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    let result = messages;
    if (statusFilter !== 'all') {
      result = result.filter((m) => m.status === statusFilter);
    }
    if (search.trim()) {
      const q = search.toLowerCase();
      result = result.filter(
        (m) => m.name.toLowerCase().includes(q) || m.email.toLowerCase().includes(q),
      );
    }
    return result;
  }, [messages, statusFilter, search]);

  return (
    <>
      <Head title="Mensagens — Administração" />
      <div className="space-y-5">
        <h1 className="font-headline text-on-surface text-2xl font-bold">Mensagens</h1>

        <div className="flex flex-wrap items-center gap-3">
          <FilterTabs options={STATUS_TABS} value={statusFilter} onChange={setStatusFilter} />
          <SearchBar
            value={search}
            onChange={setSearch}
            placeholder="Pesquisar por referência, nome ou email..."
          />
        </div>

        <div className="surface-card overflow-hidden">
          <MessagesTable
            messages={filtered}
            onRowClick={(m) => router.visit(`/messages/${m.id}`)}
          />
        </div>
      </div>
    </>
  );
}
